import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import DocumentDetail from '../components/DocumentDetail';
import './DocumentView.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

function DocumentView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Reset state when id changes
    if (!id) {
      setLoading(false);
      setDocument(null);
      setError(null);
      return;
    }
    
    // Reset state
    setDocument(null);
    setError(null);
    setLoading(true);
    
    const fetchDocument = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/insurance-documents/${id}`);
        setDocument(response.data);
      } catch (err) {
        console.error('Error fetching document:', err);
        setError(err.response?.data?.detail || 'Failed to load document');
      } finally {
        setLoading(false);
      }
    };
    
    fetchDocument();
  }, [id]);

  const handleBack = () => {
    navigate('/documents');
  };

  if (loading) {
    return (
      <div className="document-view-loading">
        <div className="spinner"></div>
        <p>Loading document...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="document-view-error">
        <span className="error-icon">❌</span>
        <span>{error}</span>
        <button onClick={handleBack} className="back-button">Back to Documents</button>
      </div>
    );
  }

  if (!document) {
    return (
      <div className="document-view-error">
        <span>Document not found</span>
        <button onClick={handleBack} className="back-button">Back to Documents</button>
      </div>
    );
  }

  return (
    <div className="document-view-page">
      <DocumentDetail document={document} onBack={handleBack} />
    </div>
  );
}

export default DocumentView;

